import { render } from "./LyricsNum.vue?vue&type=template&id=0729fc58&scoped=true"
import script from "./LyricsNum.vue?vue&type=script&lang=js"
export * from "./LyricsNum.vue?vue&type=script&lang=js"

import "./LyricsNum.vue?vue&type=style&index=0&id=0729fc58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0729fc58"]])

export default __exports__